// extracted by mini-css-extract-plugin
var _1 = "IntegrationsImportLog-modulebody__Cj3Lg";
export { _1 as "body" }
